// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"279":"QueuePage","773":"QueuesPage","789":"LoginPage","845":"Page404","846":"RegisterPage"}[chunkId] || chunkId) + "." + {"99":"a603c2a1","279":"22d85017","496":"3dc19664","773":"acef132c","789":"57de0817","845":"b5c25481","846":"275a25b7"}[chunkId] + ".chunk.js";
};